module.exports = __webpack_public_path__ + "img/companies.931c401a.svg";